componentRegistryInstance.register('editor', 'edit', 'hrd.components.form.EditorComponent');

hrd.components.form.EditorComponent = hrd.components.form.AbstractTextAreaComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.EditorComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		/* specific for Editor */

		const fieldName = field.data('name');
		const fieldEditorData = $.evaluate(field.data('editor'), this.settings.reference);
		let fieldEditorOptions = fieldEditorData.options || {};

		field.attr('name', fieldName);

		const options = $.extend({
			dashlet: this.settings.reference,
			formInstance: this.getFormInstance()
		}, fieldEditorOptions);

		const editor = $.evaluate('new impl(fieldName, options)', this.getFormInstance(), [$.evaluate(fieldEditorData.impl), fieldName, options], ['impl', 'fieldName', 'options']);

		field.data('editor-instance', editor);

		/* --------------- */
		this._super(field, id, klass);
	},
});